import { render, staticRenderFns } from "./InferenceFeedback.vue?vue&type=template&id=78a90c54&scoped=true"
import script from "./InferenceFeedback.vue?vue&type=script&lang=js"
export * from "./InferenceFeedback.vue?vue&type=script&lang=js"
import style0 from "./InferenceFeedback.vue?vue&type=style&index=0&id=78a90c54&prod&scoped=true&lang=css"
import style1 from "./InferenceFeedback.vue?vue&type=style&index=1&id=78a90c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a90c54",
  null
  
)

export default component.exports